import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import connectApi from 'api/connectApi'
import { constants } from 'helpers'
import {
    UserPermissionSliceNames,
    UserPermissionsType
} from 'storeTypes/userPermissionsTypes'

export const getUserPermissionsAction = createAsyncThunk<
    [string],
    void,
    { rejectValue: string }
>(
    UserPermissionSliceNames.userPermissionsGet,
    async (_, { dispatch, rejectWithValue }) => {
        const { PERMISSIONS } = constants.endpoints

        const storedPermissions = localStorage.getItem(
            constants.USER_PERMISSIONS
        )
        if (storedPermissions) {
            try {
                const parsed = JSON.parse(storedPermissions) as [string]
                dispatch(setPermissions(parsed))
            } catch (_) {}
        }

        try {
            const userPermissionsResponse = await connectApi.get(PERMISSIONS)
            const { permissions } = userPermissionsResponse.data as {
                permissions: [string]
            }
            localStorage.setItem(
                constants.USER_PERMISSIONS,
                JSON.stringify(permissions)
            )
            return permissions
        } catch (_error) {
            return rejectWithValue('Erreur lors du chargement des permissions')
        }
    }
)

const initialState: UserPermissionsType = {
    loading: false,
    permissionsError: '',
    permissions: []
}

const userPermissionsSlice = createSlice({
    name: UserPermissionSliceNames.userPermissions,
    initialState,
    reducers: {
        setPermissions: (state, action: PayloadAction<[string]>) => {
            state.permissions = action.payload
            state.permissionsError = ''
            state.loading = false
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getUserPermissionsAction.pending, (state) => {
            state.loading = true
            state.permissionsError = ''
        })
        builder.addCase(getUserPermissionsAction.fulfilled, (state, action) => {
            state.loading = false
            state.permissions = action.payload
        })
        builder.addCase(getUserPermissionsAction.rejected, (state, action) => {
            state.loading = false
            state.permissions = []
            state.permissionsError =
                action.payload ||
                'Un problème est survenu lors du chargement des permissions'
        })
    }
})

export const { setPermissions } = userPermissionsSlice.actions
export default userPermissionsSlice.reducer
